/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { Delete as DeleteIcon } from '@mui/icons-material';
import DeleteModal from "components/deletemodal/deletemodal";
import { loadingAction } from "ReduxReducers/loadingReducer";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { ResendEmail } from "utils/invoiceAPI";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EmailIcon from '@mui/icons-material/Email';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import IconMenu from "components/CustomMaterialMenu/Custom";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import SearchField from "components/SearchField/SearchField"; import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { toast } from "react-toastify";
import { Delete } from "@mui/icons-material";
import { formatCurrencyAUD } from "utils/formatCurrency";

const SCREEN_NAME = "Invoices";
let SCREEN_RIGHT;

function InvoicesSearch() {
  const [resetClicked, setResetClicked] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  let currency = useSelector((state) => state.currency.currencySymbol);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const dispatch = useDispatch();
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [values, setValues] = useState({
    _id: [],
    businessUserID: loginDetails?.businessUserID,
    // contactID: '',
    sortingType: "",
    sortingField: "",
    invoiceStatus: "All",
    activityStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    sendEmailFlag: false,
    searchParameterList: ['invoiceStatus', 'activityStatus', 'invoiceDate', 'dueDate', 'customerName', 'invoiceNumber', 'quotationNumber', 'lastEmailSentDate', 'paymentStatus', 'customerCompanyName', 'purchaseOrderNumber'],
  });

  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "Invoices",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });

  const [screenAccess, setScreenAccess] = useState(false);

  useEffect(() => {
    if (resetClicked) {
      fetchInvoices();
      setResetClicked(false);
    }

  }, [resetClicked]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let duration = new URLSearchParams(window.location.search).get('duration');
        let customFrom = new URLSearchParams(window.location.search).get('from');
        let customTo = new URLSearchParams(window.location.search).get('to');
        console.log("sdvhdvdjs", duration, customFrom, customTo)
        duration && (values.durationDate = duration)
        customFrom && (values.fromDate = customFrom)
        customTo && (values.toDate = customTo)
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await fetchInvoices();

      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();

  }, [values.invoiceStatus, values.activityStatus, perPage]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    setScreenAccess(SCREEN_RIGHT === 'Full Access' ? true : false);
  }

  const fetchInvoices = async () => {
    setLoading(true);
    values.perPage = perPage;
    values.token = loginDetails.token;
    // Check token
    console.log("fetchInvoices - Token:", loginDetails.token);
    await axios.post(appConstants.baseURL + 'invoice/fetchInvoices', values)
      .then(
        (res) => {
          setRows(res.data.Result_Output.docs);
          setTotalRows(res.data.Result_Output.totalDocs);
          setLoading(false);

        }
      ).catch(
        (error) => {
          setLoading(false);
          console.log("Error in fetchInvoices =", error.message)
        }
      );
  }
  // const handleResendEmail = async (selectedRow) => {
  //   ShowSwalWithButtons(
  //     'Are you sure?', `Would you like to ${selectedRow.emailSent ? "Resend" : "Send"} Email?`, 'warning', darkMode,
  //     () => {
  //       ResendEmail({ invoiceID: selectedRow._id }, (data) => {
  //         let status = data.Result_Status;
  //         showResMsg(data.Result_Message, 2000, status);
  //         fetchInvoices();
  //       }, dispatch);
  //     }
  //   );

  // }
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  };
  const handleSend = (templateData) => {
    console.log("templateData", templateData)
    const formdata = new FormData()
    formdata.append("selectedID", templateData.selectedID)
    formdata.append("userEmailAddress", templateData.userEmailAddress)
    formdata.append("customerEmailAddress", [...templateData.customerEmailAddress])
    formdata.append("emailTemplate", JSON.stringify({ ...templateData.emailTemplate }))
    formdata.append("sendMeCopy", templateData.sendMeCopy)
    formdata.append("file", templateData.uploadDocument)
    formdata.append("fileName", new Date());
    formdata.append("businessUserID", values.businessUserID);
    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
      invoiceDoc: templateData.uploadDocument,
    };
    dispatch(loadingAction(true));
    ResendEmail(formdata, (data) => {
      let status = data.Result_Status;
      showResMsg(data.Result_Message, 2000, status);
      dispatch(loadingAction(true));
      fetchInvoices();
    }, dispatch);
    values.sendEmailFlag = true;
    values.templateValues = payload;
    setOpen(false)
  }

  const handleResendEmail = async (selectedRow) => {
    console.log("selected", selectedRow)
    if (!selectedRow.finalAmount || selectedRow.finalAmount <= 0) {
      toast.error("No item added");
    } else {
      if (AllKeysHaveValue(templateValues)) {
        setOpen(true);
      } else {
        await getEmailAndTemplateForQuotation({
          screenType: templateValues.screenType, contactID: selectedRow.contactID, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "")
        }, (data) => {
          console.log("datafdfd", data.Result_Output)
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg(data.Result_Message, 2000, false);
            setOpen(false);
          }
        }, dispatch);
      }
    }

  }

  const handleCloneInvoice = async (id, invoiceNo) => {
    ShowSwalWithButtons(
      'Are you sure?', `Would you like to Clone the Invoice ${invoiceNo}?`, 'warning', darkMode,
      () => {
        dispatch(loadingAction(true));
        let payload = { businessUserID: values.businessUserID, invoiceID: id, userID: loginDetails?._id }
        axios.post(appConstants.baseURL + "invoice/cloneInvoice", payload,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
        ).then(res => {
          dispatch(loadingAction(false));
          let status = res.data.Result_Status;
          console.log("status78", status)
          //Change this code with model popup.
          if (res.data.Result_Output === "NO AVAILABLE CREDITS") {
            setShowBillingModal(true);

          } else {
            console.log("res.data.Result_Output78", res.data.Result_Output)
            showResMsg(res.data.Result_Message, 2000, status, navigate, status === true ? `/invoices/edit/${res.data.Result_Output._id}` : "");

          }
        }).catch(error => {
          dispatch(loadingAction(false));
          console.log("Error in cloneInvoice", error);
        })
      }
    );
  }

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = async (column, sortDirection) => {
    values.sortingField = column;
    values.sortingType = sortDirection;
    await fetchInvoices();
  };

  const handlePageChange = page => {
    values.page = page;
    fetchInvoices();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    setLoading(false);
  };

  const handleDeleteDialogeClick = async (value) => {
    values._id = value;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };


  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteInvoice();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const deleteInvoice = async () => {
    try {
      setLoading(true);
      values.token = loginDetails.token;
      console.log("values.token", values.token)
      await axios.post(
        appConstants.baseURL + "invoice/deleteInvoice", values
      )
        .then((res) => {
          let response = res.data;
          console.log("responsesss", response)
          if (response.Result_Status) {
            fetchInvoices();
            setTitle("");
            showResMsg(genericMessage.deleted, 1000, res.data.Result_Status);
            setLoading(false);
          } else {
            setLoading(false);
            showResMsg(response.Result_Message, 2000, false)
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteQuotation API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteQuotation API=", error);
    }
  };


  // Check if a due date is overdue
  const isOverdue = (dueDate) => {
    if (!dueDate) return false;
    const today = new Date();
    const date = new Date(dueDate);
    return date < today;
  };


  let columns = [
    {
      name: <p style={{ paddingLeft: "0px", fontSize: "12px" }}>Invoice Number</p>,
      selector: row => (
        <div>
          <Tooltip title={`View & History ${row.invoiceNumber}`}>
            <Link to={`/invoices/view/${row._id}`} style={{ fontSize: "12px", color: tableBorder, fontWeight: '600' }}>
              <span className="textUnderline">{row.invoiceNumber}</span></Link>
          </Tooltip>
        </div >),
      sortable: true,
      sortField: 'invoiceNumber',
      left: "true",
    },
    {
      name: <p style={{ paddingLeft: "0px", fontSize: "12px", }}>Customer Name</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.customerCompanyName}</span>
      ),
      sortable: true,
      sortField: 'customerCompanyName',
      minWidth: "160px"
    },
    // {
    //   name: <p style={{ paddingLeft: "0px", fontSize: "12px", }}>Customer Name</p>,
    //   selector: row => (
    //     <div>
    //       <Tooltip title={`${row.customerCompanyName} All Activity  `}>
    //         <Link to={`/invoices/activityStatement/${row.contactID}`} style={{ fontSize: "12px", color: tableBorder, fontWeight: '600' }}>
    //           <span className="textUnderline">{row.customerCompanyName.toUpperCase()}</span></Link>
    //       </Tooltip>
    //     </div >),

    //   sortable: true,
    //   sortField: 'customerCompanyName',
    //   minWidth: "160px"
    // },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Retention Number</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.retentionNumber}</span>
      ),
      sortable: true,
      sortField: 'retentionNumber',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Quotation Number</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.quotationNumber}</span>
      ),
      sortable: true,
      sortField: 'quotationNumber',
      center: 'true',
    },
    {

      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Invoice Date</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.invoiceDate}</span>
      ),
      sortable: true,
      sortField: 'invoiceDate',
      center: 'true',
      minWidth: "150px"
    },


    // Old Code
    // {
    //   name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Due Date</p>,
    //   selector: row => (

    //     <span style={{ fontSize: "12px", color: "#FF0000" }}>{row.dueDate}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'dueDate',
    //   center: "true",
    //   minWidth: "130px"
    // },

    //New Code by Anuj 4-Dec-2025
    {
      name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Due Date</p>,
      sortable: true,
      sortField: 'dueDate',
      center: "true",
      minWidth: "130px",
      cell: row => (
        <span
          style={{
            fontSize: "12px",
            color: isOverdue(row.dueDate) ? "#FF0000" : darkMode ? "white" : "black",
            fontWeight: isOverdue(row.dueDate) ? "bold" : "normal"
          }}
        >
          {row.dueDate}

        </span>
      )
    },
    {
      name: <p style={{ paddingLeft: "0px", fontSize: "12px" }}>Reference Number</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.purchaseOrderNumber}</span>
      ),
      sortable: true,
      sortField: 'purchaseOrderNumber',
      left: 'true',
      minWidth: '100px'
    },
    {
      name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}>Payment Status</p>,
      selector: row => row.invoiceStatus,

      sortable: true,
      sortField: "invoiceStatus",
      center: true,
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.invoiceStatus || "N/A"}
        </span>
      )
    },

    // {
    //   name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}>Payment Status</p>,
    //   selector: row => (
    //     <span style={{ fontSize: "12px" }}>{row.invoiceStatus}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'invoiceStatus',
    //   center: "true",
    // },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Last Email Sent</p>,
      selector: row => (
        <Tooltip title={`${row.emailSent} Email(s) sent so far`}><span style={{ fontSize: "12px", cursor: "help", textDecoration: "underline" }}>{row.lastEmailSentDate}</span></Tooltip>
      ),
      sortable: true,
      sortField: 'lastEmailSentDate',
      center: 'true',
    },
    {
      name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}>{`Pending Amount (${currency})`}</p>,

      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.paymentStatus)}</span>
      ),
      sortable: true,
      sortField: 'paymentStatus',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Activity Status</p>,
      selector: row => (<span style={{ fontSize: "12px", color: darkMode ? "#18e144" : "green" }}>{row.activityStatus}</span>),
      sortable: true,
      sortField: 'activityStatus',
      center: 'true',
    },
    {
      name: <p style={{ fontSize: "12px" }}>Actions</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      cell: row => <IconMenu
        size="small"
        row={
          <>
            <Grid style={{ width: "100%" }}>
              {row.invoiceStatus === "Unpaid" ?
                <Link to={`/invoices/edit/${row._id}`} disabled={!screenAccess}>
                  <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                    <TimelineItem color="success"
                      icon={<EditIcon className="actionicon" />}
                      title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
                </Link>
                :
                row.invoiceStatus === "Partial Paid" ?
                  <Link to={`/invoices/payment/${row._id}`} disabled={!screenAccess}>
                    <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                      <TimelineItem color="success"
                        icon={<EditIcon className="actionicon" />}
                        title="Partial Payment" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Update Payment</p>
                  </Link>
                  :
                  <p className="not-allowed" style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                    <TimelineItem color="grey"
                      icon={<EditIcon className="actionicon" />}
                      title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
              }
            </Grid>
            <Grid style={{ width: "100%" }}>
              {/* {row.payablePendingAmount !== 0 ? */}
              <Link to={`/invoices/view/${row._id}`} >
                <p style={darkMode ? { color: "white" } : { color: "black" }} >
                  <TimelineItem color="info"
                    icon={<VisibilityIcon className="actionicon" />}
                    title="View & History" />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;View & History
                </p>
              </Link>

            </Grid>

            <Grid style={{ width: "100%" }}>
              {row.activityStatus !== "Sent" && row.invoiceStatus !== "Paid" ? (
                <p
                  onClick={() => handleDeleteDialogeClick(row._id)}
                  style={darkMode ? { color: "white", cursor: "pointer" } : { color: "black", cursor: "pointer" }}
                >
                  <TimelineItem
                    color="error"
                    icon={<DeleteIcon className="actionicon" />}
                    title="Delete"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
              ) : (
                <p
                  style={{
                    color: darkMode ? "white" : "black",
                    opacity: 0.5,
                    cursor: "not-allowed",
                  }}
                >
                  <TimelineItem
                    color="grey"
                    icon={<DeleteIcon className="actionicon" />}
                    title="Delete"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
              )}

              {/* {row.activityStatus !== "Sent" || row.invoiceStatus !== "Paid" ?
                <p onClick={() => handleDeleteDialogeClick(row._id)} style={darkMode ? { color: "white" } : { color: "black" }} >
                  <TimelineItem color="error"
                    icon={<DeleteIcon className="actionicon" />}
                    onClick={() => handleDeleteDialogeClick(row._id)}
                    title="Delete" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
                :
                <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                  <TimelineItem color="grey"
                    icon={<DeleteIcon className="actionicon" />}
                    title="Delete" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                </p>
              } */}

            </Grid>

            <Grid >
              {row.invoiceStatus !== "Paid" ?
                <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleResendEmail(row)} disabled={!screenAccess}>
                  <TimelineItem color="error"
                    icon={<EmailIcon className="actionicon" />}
                    title={row.emailSent > 0 ? "Resend Email" : "Send Email"}
                    onClick={() => handleResendEmail(row)} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {row.emailSent > 0 ? "Resend Email" : "Send Email"}</p>
                :
                <p disabled
                  style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }}>
                  <TimelineItem color="grey"
                    icon={<EmailIcon className="actionicon" />} disabled={!screenAccess}
                    title="Resend Email" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Resend Email</p>
              }
            </Grid>
            <Grid >
              {row.invoiceType === "Direct" ?
                <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => { handleCloneInvoice(row._id, row.invoiceNumber) }} disabled={!screenAccess}>
                  <TimelineItem color="warning"
                    icon={<ContentCopyIcon className="actionicon" />}
                    title=" Clone Invoice" onClick={() => { handleCloneInvoice(row._id, row.invoiceNumber) }} /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clone Invoice</p>

                :
                <Tooltip title="You cannot create clone of  Invoice through Quotation">
                  <p disabled
                    style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }}>
                    <TimelineItem color="grey"
                      icon={<ContentCopyIcon className="actionicon" />} disabled={!screenAccess}
                      title="Clone Invoice" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clone Invoice
                  </p>
                </Tooltip>
                // <p disabled
                //   style={{ color: darkMode ? "white" : "black", cursor: "not-allowed" }}>
                //   <TimelineItem color="grey"
                //     icon={<ContentCopyIcon className="actionicon" />}
                //     title="Clone Invoice" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clone Invoice</p>
              }
            </Grid>

            <Grid style={{ width: "100%" }}>
              <Link to={`/invoices/invoice/${row.invoiceNumber}/${row._id}?type=preview&download`} disabled={!screenAccess}>
                <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                  <TimelineItem color="#87CEEB"
                    icon={<DownloadIcon className="actionicon" />}
                    title="Download Invoice"
                  //  onClick={() => { handleDisplayDialogeClick(row._id) }}
                  />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preview/Download</p>
              </Link>
            </Grid>
          </>
        } />,
    },
  ];
  const handleAddNew = () => {
    if (!screenAccess) {
      showResMsg(genericMessage.notPermission, 2000, false);
    } else {
      navigate("/invoices/add?type=new");
    }
  }
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues(prevValues => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchInvoices();
  }, [values.filterValues]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();
    }
  }, [values.filterValues]);


  const handleRefreshButtonClick = () => {
    // fetchQuotations();
    setValues((prevValues) => ({
      ...prevValues,
      _id: [],
      businessUserID: loginDetails?.businessUserID,
      // contactID: '',
      sortingType: "",
      sortingField: "",
      invoiceStatus: "All",
      activityStatus: "All",
      durationDate: "",
      fromDate: "",
      toDate: "",
      page: appConstants.page,
      limit: appConstants.limit,
      filterValues: "",
      sendEmailFlag: false,
      searchParameterList: ['invoiceStatus', 'activityStatus', 'invoiceDate', 'dueDate', 'customerName', 'invoiceNumber', 'quotationNumber', 'lastEmailSentDate', 'paymentStatus', 'customerCompanyName', 'purchaseOrderNumber'],
    }));
    setResetClicked(true);
  }


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Invoices" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <MDButton
              rel="noreferrer"
              variant="gradient"
              color="success"
              style={{ height: "38.11px !important" }}
              // fullWidth
              onClick={handleRefreshButtonClick}

            >
              <RefreshIcon color="light" sx={{ cursor: "pointer" }} />
            </MDButton>
            <Grid item lg={1.5} xs={6} >
              <FormControl fullWidth >
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.invoiceStatus}
                  onChange={(e) => setValues({ ...values, invoiceStatus: e.target.value })}
                  className="selectfield"

                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={1.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Activity Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Activity Status"
                  value={values.activityStatus}
                  onChange={(e) => setValues({ ...values, activityStatus: e.target.value })}

                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Draft">Draft</MenuItem>
                  <MenuItem value="Viewed">Viewed</MenuItem>
                  <MenuItem value="Sent">Sent</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              />
              {/* <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchInvoices();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchInvoices}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>

            <MDButton
              variant="contained"
              color="success"
              style={{ height: "38.11px" }}
              className={(!screenAccess ? (darkMode ? "disabledInDarkMode" : "disabledInLightMode") : "")}
              onClick={handleAddNew}
            >
              Add New
            </MDButton>


            <Grid>
              <div style={{ marginRight: '16px' }}>
                <MDButton
                  variant="contained"
                  color="warning"
                  style={{ height: "38.11px" }}
                  onClick={() => { navigate("/contacts?customertype=Customer") }}
                >
                  Show Statement
                </MDButton>

              </div>
            </Grid>
          </Grid>
          <BTable
            columns={columns}
            data={rows}
            sortServer
            sortingType={handleSort}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />

      <LoadingModal loading={loading} />

      {/* {showBillingModal && <BillingModal
        open={showBillingModal}
        handleConfirm={() => { navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />} */}

      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}
    </DashboardLayout>
  );
}
export default InvoicesSearch;
